/**
 * utils.js — Funzioni di utilità pure (nessuna dipendenza da altri moduli).
 */

// "dd/mm/yy" o "dd/mm/yyyy" → "dd/mm/yyyy"
function normalizeDate(raw) {
    if (!raw) return '';
    if (raw.includes('/')) {
        const p = raw.split('/');
        const y = p[2] && p[2].length === 2 ? '20' + p[2] : (p[2] || '');
        return `${p[0]}/${p[1]}/${y}`;
    }
    const d = new Date(raw);
    if (!isNaN(d)) {
        return [
            String(d.getDate()).padStart(2, '0'),
            String(d.getMonth() + 1).padStart(2, '0'),
            d.getFullYear(),
        ].join('/');
    }
    return raw;
}

// "dd/mm/yyyy" → "Ven, 10 Aprile, 2026"
function formatDateLabel(raw) {
    if (!raw) return 'Data non inserita';
    const p = raw.split('/');
    if (p.length !== 3) return raw;
    const d = new Date(p[2], p[1] - 1, p[0]);
    if (isNaN(d)) return raw;
    const days   = ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'];
    const months = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
                    'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
    return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]}, ${d.getFullYear()}`;
}

// Invia evento al dataLayer di Google Tag Manager
function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
}

// Label leggibile del tipo di prenotazione
function reservationTypeLabel(type) {
    return {
        andata:                    'Solo Andata',
        andata_ritorno_attesa:     'Andata & Ritorno (con attesa)',
        andata_ritorno_richiamata: 'Andata & Ritorno (con richiamata)',
        andata_ritorno_orari_def:  'Andata & Ritorno (orario prestabilito)',
    }[type] || type;
}
